<template>
	<el-dialog @close="close" center :visible.sync="dialogVisible" width="35%">
		<div style="padding: 0 0.2rem;">
			<p class="p1">{{ title }}</p>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px" class="demo-ruleForm">
				<el-form-item label="登录手机" prop="loginAccount">
					<el-input style="width: 4rem;" placeholder="请输入手机号" v-model="ruleForm.loginAccount"></el-input>
				</el-form-item>
				<el-form-item label="登录名称" prop="userName">
					<el-input style="width: 4rem;" placeholder="请输入用户名称/用户昵称 用户可登录后自行调整"
						v-model="ruleForm.userName"></el-input>
				</el-form-item>
				<el-form-item label="邮箱地址" prop="email">
					<el-input style="width: 4rem;" placeholder="请输入用户名称/用户昵称 用户可登录后自行调整"
						v-model="ruleForm.email"></el-input>
				</el-form-item>
			</el-form>
			<div class="lineBox1">
				<p class="p3">
					是否可使用公司账户进行订单支付
				</p>
				<el-switch v-model="ruleForm.isPay" active-color="#617AEC" inactive-color="#9E9E9E">
				</el-switch>
			</div>
			<div class="lineBox1">
				<p class="p3">
					是否是可接单的定制师
				</p>
				<el-switch v-model="ruleForm.isReceivingOrders" active-color="#617AEC" inactive-color="#9E9E9E">
				</el-switch>
			</div>
			<!-- <div class="lineBox1">
				<div>
					<span class="p3" style="margin-right: 0.2rem;">
						接单区域选择
					</span>
					<el-select style="width: 3rem;" size="medium" placeholder="请选择">
						<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
				</div>
				<i style="font-size: 0.24rem;cursor: pointer;" class="el-icon-circle-plus-outline"></i>
			</div> -->
			<!-- <div class="footer">
				<div style="margin-right: 0.24rem;display: flex;align-items: center;"
					v-for="item in ruleForm.platSupplierAreas" :key="item.id">
					<p class="p4">{{ item.nameCn }}</p>
					<i @click="delArea(item)" style="color:rgba(221, 88, 39, 1);font-size: 0.2rem;cursor: pointer;"
						class="el-icon-circle-close"></i>
				</div>
			</div> -->
		</div>
		<span slot="footer" class="dialog-footer">
			<div v-if="JSON.stringify(stateSw) !== '{}'">
				<el-button type="primary" @click="modifyStateClick"> {{ stateSw.keys == 1 ? '确认停用该用户' : '确认恢复该用户' }}
				</el-button>
			</div>
			<div v-else>
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="save('ruleForm')">保 存</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import Api from "@/components/Api/index";
export default {
	data() {
		return {
			ruleForm: {},
			stateSw: {},//如果为真 说明是停用或恢复
			rules: {
				loginAccount: [
					{ required: true, message: "请输入手机号码", trigger: "blur" },
					{
						validator: function (rule, value, callback) {
							if (/^1[3456789]\d{9}$/.test(value) == false) {
								callback(new Error("请输入正确的手机号"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				],
				userName: [
					{ required: true, message: "名称不能为空", trigger: "blur" },
					{ min: 1, max: 5, message: '长度在 1 到 5 个字符', trigger: 'blur' }
				],
				email: [
					{
						validator: function (rule, value, callback) {
							if (/^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/.test(value) == false && value) {
								callback(new Error("请输入正确的邮箱号码"));
							} else {
								callback();
							}
						},
						trigger: "blur",
					},
				]

			},
			dialogVisible: false,
			title: '添加机构子账户',
			options: [{
				value: '1',
				label: '黄金糕'
			}, {
				value: '2',
				label: '双皮奶'
			}],
		}
	},
	methods: {
		init(val, obj) {
			this.stateSw = {}
			console.log(val, obj, '大撒打算打算的');
			if (obj) {
				this.stateSw = obj
			} else {
				this.title = val.id ? '修改机构子账户' : '添加机构子账户'
			}
			this.ruleForm = JSON.parse(JSON.stringify(val))
			this.dialogVisible = true
		},
		close() {
			this.$refs["ruleForm"].resetFields();
		},
		//删除接单区域
		delArea(item) {

		},
		//修改用户状态
		modifyStateClick() {
			let obj = JSON.parse(JSON.stringify(this.ruleForm))
			obj.status = this.stateSw.title === '批量停用' ? 2 : 1
			let data = [obj]
			new Api("user")
				.updateUserList(data)
				.then((res) => {
					if (res.status == 200) {
						this.$message({
							type: 'success',
							message: `${this.stateSw.title === '批量停用' ? '停用' : '恢复'}成功!`
						});
						let sw = {
							'2': {
								title: '批量停用',
								name: '正常状态',
								keys: 1,
								text: '确认批量停用上述员工账号',
							},
							'1': {
								title: '批量恢复',
								name: '停用状态',
								keys: 2,
								text: '确认批量恢复上述员工账号',
							}
						}
						this.$emit('updateStatue', sw[this.stateSw.keys])
						this.dialogVisible = false
					} else {
						this.$message.error(res.statusText);
					}
				})
				.catch(() => {
					this.$message({
						type: "error",
						message: "系统异常!",
					});
				});
		},
		//保存
		save(formName) {
			console.log(this.ruleForm, '撒打算打算大撒的');
			this.$refs[formName].validate((valid) => {
				if (valid) {
					new Api("user").userAdd(this.ruleForm)
						.then((res) => {
							if (res.status == 200) {
								this.$message.success(this.ruleForm.id ? '修改成功' : '新增成功')
								this.$emit('update')
								this.dialogVisible = false
							} else {
								this.$message.error(res.statusText);
							}
						}).catch(() => {
							this.$message({
								type: "error",
								message: "系统异常!",
							});
						});
				} else {
					return false;
				}
			});

		}
	}
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item__label {
	text-align: left !important;
}

.p1 {
	color: rgba(16, 16, 16, 1);
	font-size: 0.16rem;
	font-weight: bold;
	font-family: SourceHanSansSC-bold;
	margin-bottom: 0.24rem;
}

.lineBox {
	display: flex;
	align-items: center;
	margin-bottom: 0.14rem;

	.p2 {
		position: relative;
		width: 0.64rem;
		color: rgba(16, 16, 16, 1);
		font-size: 0.16rem;
		font-family: SourceHanSansSC-regular;
		display: flex;
		align-items: center;
		margin-right: 0.32rem;

		.imgs {
			position: absolute;
			width: 0.14rem;
			left: -0.15rem;
		}
	}
}

.lineBox1 {
	display: flex;
	align-items: center;
	margin-bottom: 0.14rem;
	justify-content: space-between;

	.p3 {
		color: rgba(16, 16, 16, 1);
		font-size: 0.16rem;
		font-family: SourceHanSansSC-regular;
	}
}

.footer {
	display: flex;
	align-items: center;
	flex-wrap: wrap;

	.p4 {
		color: rgba(221, 88, 39, 1);
		font-size: 0.16rem;
		font-family: SourceHanSansSC-regular;
		margin-right: 0.05rem
	}
}
</style>
